export default __webpack_public_path__ + "b63390e61869914fa16eee5c5c738583.png";